import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "Are your courses accredited?", a: "No. Our courses provide general educational information and a 'Certificate of Completion'. They are not accredited, government-approved, or licensed." },
  { q: "Can I preview courses for free?", a: "Yes. Every course includes one or more free preview lessons. Full content unlocks after purchase." },
  { q: "Do I get a certificate?", a: "Yes — once you complete all lessons, pass module quizzes, and pass the final test, you can download a PDF Certificate of Completion." },
  { q: "What's the AI Tutor?", a: "An in-course AI assistant that answers your questions based on the course content. Available for paid students inside each course." },
  { q: "Can I get a refund?", a: "See our Refund Policy. Refunds may be offered within a limited window if minimal course content has been consumed." },
  { q: "Do you offer French courses?", a: "Yes. We have French language courses, and many other courses can be generated in French via 'Create Your Learning Path'." },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="faq-page">
      <div className="label-eyebrow">FAQ</div>
      <h1 className="font-display font-black text-4xl md:text-5xl mt-2 tracking-tight">Frequently asked questions</h1>
      <div className="mt-10">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-${i}`}>
              <AccordionTrigger className="font-display font-bold text-left">{f.q}</AccordionTrigger>
              <AccordionContent className="text-[#4B5563]">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
